import React, { useContext } from "react";
import { Link } from "react-router-dom";
import navCardBg from '../../assets/images/layout/nav-card-bg.svg';
import logoDark from '../../assets/images/logo-dark.svg';
import logoLight from '../../assets/images/logo-white.svg';
import avatar1 from "../../assets/images/user/avatar-1.jpg";
import SimpleBar from "simplebar-react";
import NestedMenu from "./components/NestedMenu";
import { Card, CardBody } from "react-bootstrap";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { useMenuItems } from "./MenuData";


const Sidebar2 = ({ themeMode, mobileOpen }: any) => {
    const auth = useContext(AuthContext);
    const { user } = auth;
    const { theme } = useTheme();

    // Fetch menu items with translations
    const menuItems = useMenuItems();

    return (
        <React.Fragment>
            <nav className={`pc-sidebar${mobileOpen ? ' mob-sidebar-active' : ''}`} id="pc-sidebar-hide">
                <div className="navbar-wrapper">
                    <div className="m-header w-75">
                        <Link to="/" className="b-brand text-primary">
                            {theme === "dark" ? (
                                <img src={logoLight} alt="logo" className="logo-lg landing-logo img-fluid" style={{ width: "100%", height: "100%", minHeight: "100px" }} />
                            ) : (
                                <img src={logoDark} alt="logo" className="logo-lg landing-logo img-fluid" style={{ width: "100%", height: "100%", minHeight: "100px" }} />
                            )}
                        </Link>
                    </div>

                    <SimpleBar className="navbar-content" style={{ maxHeight: "100vh" }}>
                        <ul className="pc-navbar" id="pc-navbar">
                            <NestedMenu menuItems={menuItems} />
                        </ul>
                    </SimpleBar>
                    <Card className="pc-user-card">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img
                                        src={user?.profilePicture?.path || avatar1}
                                        alt="user-image"
                                        className="user-avtar wid-45 hei-45 object-fit-cover rounded-circle"
                                        width={45}
                                        onError={(e) => (e.currentTarget.src = avatar1)}
                                    />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h6 className="mb-0">{user?.firstName} {user?.lastName}</h6>
                                    <p className="mb-0 text-muted">{user?.email}</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </nav>
        </React.Fragment>
    );
};

export default Sidebar2;
